import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import FilledInput from "@mui/material/FilledInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Autocomplete, Dialog, DialogContent, DialogContentText, OutlinedInput, TextField } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useState } from "react";
import { Properties } from "../../util/All_interfaces";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";

const formatNumber = (params: any) => {
  if (params !== null)
      return params.toLocaleString('en-US');
  }

class DecimalFormating {

  formatToTwoDecimalPlaces = (input:string | number) => {
      const numberVlaue = parseFloat(input as string);
      return isNaN(numberVlaue) ? '' : numberVlaue.toFixed(2);
  }
}
  
const PopUpTablecomponent = (props: any) => {
  return (
    <>
      <TableContainer component={Paper}>
        <Table
          sx={{ minWidth: 650 }}
          size="small"
          aria-label="a dense table"
          className="global-appraisal-property-table"
        >
          <TableHead>
            <TableRow>
              <TableCell>Property Details</TableCell>
              <TableCell>Current Value</TableCell>
              <TableCell>Prior Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Currency</TableCell>
              <TableCell>{props.currentData[0]?.currency === null || props.currentData.length == 0 ? "" : props.currentData[0]?.currency}</TableCell>
              <TableCell>{props.priorData[0]?.currency === null || props.priorData.length == 0  ? "" : props.priorData[0]?.currency}</TableCell>
            </TableRow>
            {
              (props.isGermanFund) &&
              <TableRow>
                <TableCell>Property Value Date</TableCell>
                <TableCell>{props.currentData[0]?.propertyValueDate === null || props.currentData.length == 0 ? "" : dayjs(props.currentData[0]?.propertyValueDate).format('MMM-DD-YYYY')}</TableCell>
                <TableCell>{props.priorData[0]?.propertyValueDate === null || props.priorData.length == 0 ? "" : dayjs(props.priorData[0]?.propertyValueDate).format('MMM-DD-YYYY')}</TableCell>
              </TableRow>
            }
            <TableRow>
              <TableCell>Net Rent Passing</TableCell>
              <TableCell>{props.currentData[0]?.netRentPassing === null || props.currentData.length == 0  ? "" : formatNumber(Number(props.currentData[0]?.netRentPassing))}</TableCell>
              <TableCell>{props.priorData[0]?.netRentPassing === null || props.priorData.length == 0  ? "" : formatNumber(Number(props.priorData[0]?.netRentPassing))}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Rental Value</TableCell>
              <TableCell>{props.currentData[0]?.rentalValue === null || props.currentData.length == 0  ? "" : formatNumber(Number(props.currentData[0]?.rentalValue))}</TableCell>
              <TableCell>{props.priorData[0]?.rentalValue === null || props.priorData?.length == 0  ? "" : formatNumber(Number(props.priorData[0]?.rentalValue))}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Gross Value</TableCell>
              <TableCell>{props.currentData[0]?.grossValue === null || props.currentData.length == 0  ? "" : formatNumber(Number(props.currentData[0]?.grossValue))}</TableCell>
              <TableCell>{props.priorData[0]?.grossValue === null || props.priorData.length == 0  ? "" : formatNumber(Number(props.priorData[0]?.grossValue))}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Capital Expenditure</TableCell>
              <TableCell>{props.currentData[0]?.capitalExpenditure === null || props.currentData.length == 0  ? "" : formatNumber(Number(props.currentData[0]?.capitalExpenditure))}</TableCell>
              <TableCell>{props.priorData[0]?.capitalExpenditure === null || props.priorData?.length == 0  ? "" : formatNumber(Number(props.priorData[0]?.capitalExpenditure))}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Acquisition Costs</TableCell>
              <TableCell>{props.currentData[0]?.acquisitionCosts === null || props.currentData.length == 0  ? "" : formatNumber(Number(props.currentData[0]?.acquisitionCosts))}</TableCell>
              <TableCell>{props.priorData[0]?.acquisitionCosts === null || props.priorData.length == 0  ? "" : formatNumber(Number(props.priorData[0]?.acquisitionCosts))}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Net Value</TableCell>
              <TableCell>{props.currentData[0]?.netValue === null || props.currentData.length == 0  ? "" : formatNumber(Number(props.currentData[0]?.netValue))}</TableCell>
              <TableCell>{props.priorData[0]?.netValue === null || props.priorData.length == 0  ? "" : formatNumber(Number(props.priorData[0]?.netValue))}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Say Value</TableCell>
              <TableCell>{props.currentData[0]?.sayValue === null || props.currentData.length == 0  ? "" : formatNumber(Number(props.currentData[0]?.sayValue))}</TableCell>
              <TableCell>{props.priorData[0]?.sayValue === null || props.priorData.length == 0  ? "" : formatNumber(Number(props.priorData[0]?.sayValue))}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Initial Yield Valuation</TableCell>
              <TableCell>{props.currentData[0]?.initialYieldValuation === null ? "" : props.currentData[0]?.initialYieldValuation}</TableCell>
              <TableCell>{props.priorData[0]?.initialYieldValuation === null ? "" : props.priorData[0]?.initialYieldValuation}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Initial Yield Contracted</TableCell>
              <TableCell>{props.currentData[0]?.initialYieldContracted === null ? "" : props.currentData[0]?.initialYieldContracted}</TableCell>
              <TableCell>{props.priorData[0]?.initialYieldContracted === null ? "" : props.priorData[0]?.initialYieldContracted}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Nominal Equivalent Yield</TableCell>
              <TableCell>{props.currentData[0]?.nominalEquivalentYield === null ? "" : props.currentData[0]?.nominalEquivalentYield}</TableCell>
              <TableCell>{props.priorData[0]?.nominalEquivalentYield === null ? "" : props.priorData[0]?.nominalEquivalentYield}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>True Equivalent Yield</TableCell>
              <TableCell>{props.currentData[0]?.trueEquivalentYield === null ? "" : props.currentData[0]?.trueEquivalentYield}</TableCell>
              <TableCell>{props.priorData[0]?.trueEquivalentYield === null ? "" : props.priorData[0]?.trueEquivalentYield}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Reversionary Yield</TableCell>
              <TableCell>{props.currentData[0]?.reversionaryYield === null ? "" : props.currentData[0]?.reversionaryYield}</TableCell>
              <TableCell>{props.priorData[0]?.reversionaryYield === null ? "" : props.priorData[0]?.reversionaryYield}</TableCell>
            </TableRow>

            { props.displayProformaFields && <>
              <TableRow>
                <TableCell>Terminal CapRate</TableCell>
                <TableCell>{props.currentData[0]?.terminalCapRate === null ? "" : props.currentData[0]?.terminalCapRate}</TableCell>
                <TableCell>{props.priorData[0]?.terminalCapRate === null ? "" : props.priorData[0]?.terminalCapRate}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Discount Rate</TableCell>
                <TableCell>{props.currentData[0]?.discountRate === null ? "" : props.currentData[0]?.discountRate}</TableCell>
                <TableCell>{props.priorData[0]?.discountRate === null ? "" : props.priorData[0]?.discountRate}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Assumed Holding Period</TableCell>
                <TableCell>{props.currentData[0]?.assumedHoldingPeriod === null ? "" : props.currentData[0]?.assumedHoldingPeriod}</TableCell>
                <TableCell>{props.priorData[0]?.assumedHoldingPeriod === null ? "" : props.priorData[0]?.assumedHoldingPeriod}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Growth Rates</TableCell>
                <TableCell>{props.currentData[0]?.growthRates === null ? "" : props.currentData[0]?.growthRates}</TableCell>
                <TableCell>{props.priorData[0]?.growthRates === null ? "" : props.priorData[0]?.growthRates}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Net Exit Value</TableCell>
                <TableCell>{props.currentData[0]?.netExitValue === null ? "" : props.currentData[0]?.netExitValue}</TableCell>
                <TableCell>{props.priorData[0]?.netExitValue === null ? "" : props.priorData[0]?.netExitValue}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Forward Initial Yield</TableCell>
                <TableCell>{props.currentData[0]?.forwardInitialYield === null ? "" : props.currentData[0]?.forwardInitialYield}</TableCell>
                <TableCell>{props.priorData[0]?.forwardInitialYield === null ? "" : props.priorData[0]?.forwardInitialYield}</TableCell>
              </TableRow>
            </>}

          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

const TableRowComponent = (props: any) => {

  const [open, setOpen] = React.useState(false);
  const currencyList = ['EUR', 'GBP', 'CHF', 'SEK', 'NOK', 'DKK', 'PLN', 'CZK', 'HUF', 'RON', 'BGN', 'HRK', 'TRY', 'ILS', 'ZAR', 'AED', 'SAR', 'QAR',
    'KWD', 'BHD', 'OMR', 'JOD', 'EGP', 'MAD', 'KES', 'NGN', 'JPY', 'CNY', 'HKD', 'SGD', 'AUD', 'NZD', 'KRW', 'INR', 'IDR', 'THB', 'MYR', 'PHP', 'VND',
    'TWD', 'PKR', 'BDT', 'LKR', 'MMK', 'KHR', 'LAK', 'BND', 'MOP', 'FJD', 'PGK', 'NPR'];

  const handleClickOpen = () => {
    setOpen(true);
    props.sendDataToParent(props.propertyId);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const format = new DecimalFormating(); 


  const handlePropertyValuedate = (value: any) => {
    props.handlePropertyValuedate(value, props.index);
  }

  const handleRentalValue = (value: any) => {
    props.handleRentalValue(value, props.index);
  }

  const handleNetrentpassing = (value: any) => {
    props.handleNetrentpassing(value, props.index);
  }
  const handleGrossvalue = (value: any) => {
    props.handleGrossvalue(value, props.index);
  }
  const handleCapitalexpenditure = (value: any) => {
    props.handleCapitalexpenditure(value, props.index);
  }
  const handleAcquisitioncosts = (value: any) => {
    props.handleAcquisitioncosts(value, props.index);
  }
  const handleNetvalue = (value: any) => {
    props.handleNetvalue(value, props.index);
  }
  const handleSayvalue = (value: any) => {
    props.handleSayvalue(value, props.index);
  }
  const handleInitialyieldvaluation = (value: any) => {
    // if (/^\d*\.?\d{0,2}$/.test(value)) {
    //   props.handleInitialyieldvaluation(value, props.index);
    // }
    // else if (/^\d*\.?\d{2}$/.test(value)) {
    //   props.handleInitialyieldvaluation(format.formatToTwoDecimalPlaces(value), props.index);
    // }

    props.handleInitialyieldvaluation(value, props.index);
  }
  const handleInitialyieldcontracted = (value: any) => {
    // if (/^\d*\.?\d{0,2}$/.test(value)) {
    //   props.handleInitialyieldcontracted(value, props.index);
    // }
    // else if (/^\d*\.?\d{2}$/.test(value)) {
    //   props.handleInitialyieldcontracted(format.formatToTwoDecimalPlaces(value), props.index);
    // }
    props.handleInitialyieldcontracted(value, props.index);

  }
  const handleNominalequivalentyield = (value: any) => {
    // if (/^\d*\.?\d{0,2}$/.test(value)) {
    //   props.handleNominalequivalentyield(value, props.index);
    // }
    // else if (/^\d*\.?\d{2}$/.test(value)) {
    //   props.handleNominalequivalentyield(format.formatToTwoDecimalPlaces(value), props.index);
    // }
    props.handleNominalequivalentyield(value, props.index);

  }
  const handleTrueequivalentyield = (value: any) => {
    // if (/^\d*\.?\d{0,2}$/.test(value)) {
    //   props.handleTrueequivalentyield(value, props.index);
    // }
    // else if (/^\d*\.?\d{2}$/.test(value)) {
    //   props.handleTrueequivalentyield(format.formatToTwoDecimalPlaces(value), props.index);
    // }
    props.handleTrueequivalentyield(value, props.index);

  }
  const handleReversionaryyield = (value: any) => {
    // if (/^\d*\.?\d{0,2}$/.test(value)) {
    //   props.handleReversionaryyield(value, props.index);
    // }
    // else if (/^\d*\.?\d{2}$/.test(value)) {
    //   props.handleReversionaryyield(format.formatToTwoDecimalPlaces(value), props.index);
    // }
    props.handleReversionaryyield(value, props.index);

  }
  const handleAssumedholdingperiod = (value: any) => {
    props.handleAssumedholdingperiod(value, props.index);
  }
  const handleDiscountrate = (value: any) => {
    // if (/^\d*\.?\d{0,2}$/.test(value)) {
    //   props.handleDiscountrate(value, props.index);
    // }
    // else if (/^\d*\.?\d{2}$/.test(value)) {
    //   props.handleDiscountrate(format.formatToTwoDecimalPlaces(value), props.index);
    // }
    props.handleDiscountrate(value, props.index);

  }
  const handleForwardinitialyield = (value: any) => {
    // if (/^\d*\.?\d{0,2}$/.test(value)) {
    //   props.handleForwardinitialyield(value, props.index);
    // }
    // else if (/^\d*\.?\d{2}$/.test(value)) {
    //   props.handleForwardinitialyield(format.formatToTwoDecimalPlaces(value), props.index);
    // }
    props.handleForwardinitialyield(value, props.index);

  }
  const handleGrowthrates = (value: any) => {
    // if (/^\d*\.?\d{0,2}$/.test(value)) {
    //   props.handleGrowthrates(value, props.index);
    // }
    // else if (/^\d*\.?\d{2}$/.test(value)) {
    //   props.handleGrowthrates(format.formatToTwoDecimalPlaces(value), props.index);
    // }
    props.handleGrowthrates(value, props.index);

  }
  const handleNetexitvalue = (value: any) => {
    props.handleNetexitvalue(value, props.index);
  }
  const handleTerminalCapRate = (value: any) => {
    // if (/^\d*\.?\d{0,2}$/.test(value)) {
    //   props.handleTerminalCapRate(value, props.index);
    // }
    // else if (/^\d*\.?\d{2}$/.test(value)) {
    //   props.handleTerminalCapRate(format.formatToTwoDecimalPlaces(value), props.index);
    // }
    props.handleTerminalCapRate(value, props.index);

  }

  const handleCurrency = (value: any) => {
    props.handleCurrency(value, props.index);
  }


  const formatNumberWithCommas = (num: number | string | null) => {
    if(num != null)
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');

    return "";
  }


  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "1000px",  // Set your width here
            },
          },
        }}
      >
        <DialogContent>
          <DialogContentText>
            Property : {props.propertyName}
          </DialogContentText>
          <PopUpTablecomponent currentData={props.currentData}
            priorData={props.priorData} 
            displayProformaFields={props.displayProformaFields}
            propertyValueDate={props.propertyValueDate} 
            isEditable = {props.isEditable}
            isViewForm = {props.isViewForm}
            isGermanFund = {props.isGermanFund}
          />
        </DialogContent>
      </Dialog>
      <TableRow sx={{ '&:nth-of-type(odd)': { backgroundColor: '#f2f2f2' } }}>
        <TableCell>{props.propertyId}</TableCell>
        {props.editDisplay ? <TableCell className="tableCell-global" style={{ color: "blue" }}
          onClick={handleClickOpen}>{props.propertyName} </TableCell> :
          <TableCell>{props.propertyName}</TableCell>
        }

        <TableCell>{props.propertyType}</TableCell>
        <TableCell sx={props.currencyError ? { border: '1px solid red', color: 'red' } : {}}>
          {props.isGermanFund ? (
            <Autocomplete
              freeSolo
              value={props.currency || ''}
              options={currencyList}
              size="small"
              readOnly={!props.isEditable}
              onChange={(event, newValue) => handleCurrency(newValue || '')}
              onInputChange={(event, newInputValue) => handleCurrency(newInputValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  sx={{ width: '150px' }}
                  error={props.currencyError}
                  helperText={props.currencyError ? 'Required' : ''}
                />
              )}
            />
          ) : (
            props.currency
          )}
        </TableCell>
        {(props.isGermanFund) &&
          <TableCell>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer sx={{ overflowY: 'hidden' }} components={["DatePicker", "DatePicker", "DatePicker"]}>
                <DatePicker
                  value={
                    props.propertyValueDate === "" ||
                      props.propertyValueDate == null
                      ? null :
                      dayjs(
                        props.propertyValueDate,
                        "MM-DD-YYYY"
                      )} // You'll need to manage this state
                  onChange={(newValue: any) => {
                    // Handle date change here
                    handlePropertyValuedate(newValue);
                  }}
                  format="MMM-DD-YYYY"
                  views={["month", "day", "year"]}
                  slotProps={{ textField: { size: "small", sx: { width: '150px' }, placeholder: "MMM-DD-YYYY" } }}
                  readOnly={!props.isEditable}
                />
              </DemoContainer>
            </LocalizationProvider>
          </TableCell>
        }
        <TableCell>
          <OutlinedInput value={props.netRentPassing} size="small" 
          sx={{ width: '150px' }} 
          readOnly={!props.isEditable} onChange={(e) => handleNetrentpassing(e.target.value)}/>
        </TableCell>
        <TableCell>
          <OutlinedInput type="text" value={(props.rentalValue)} size="small"
        sx={{ width: '150px' }} readOnly={!props.isEditable} onChange={(e) => handleRentalValue(e.target.value)}/>
        </TableCell>
        <TableCell>
          <OutlinedInput value={(props.grossValue)} size="small" 
          sx={{ width: '150px' }} readOnly={!props.isEditable} onChange={(e) => handleGrossvalue(e.target.value)}/>
        </TableCell>
        <TableCell>
          <OutlinedInput value={(props.capitalExpenditure)} size="small"
          sx={{ width: '150px' }} readOnly={!props.isEditable} onChange={(e) => handleCapitalexpenditure(e.target.value)}/>
        </TableCell>
        <TableCell>
          <OutlinedInput value={(props.acquisitionCosts)} size="small" 
          sx={{ width: '150px' }} readOnly={!props.isEditable} onChange={(e) => handleAcquisitioncosts(e.target.value)}/>
        </TableCell>
        <TableCell>
          <OutlinedInput value={(props.netValue)} size="small" 
          sx={{ width: '150px' }} readOnly={!props.isEditable} onChange={(e) => handleNetvalue(e.target.value)}/>
        </TableCell>
        <TableCell>
          <OutlinedInput value={(props.sayValue)} size="small" 
          sx={{ width: '150px' }} readOnly={!props.isEditable} onChange={(e) => handleSayvalue(e.target.value)}/>
        </TableCell>
        <TableCell>
          <OutlinedInput
            value={props?.initialYieldValuation}//{props.editDisplay ? (props?.initialYieldValuation != null ?  Number(props?.initialYieldValuation).toFixed(2) : '') : props?.initialYieldValuation}//{props.initialYieldValuation != '' ? (Math.round(props.initialYieldValuation * 100) / 100).toFixed(2) : ''} 
            size="small"
            sx={{ width: '150px' }} readOnly={!props.isEditable} onChange={(e) => handleInitialyieldvaluation(e.target.value)} />
        </TableCell>
        <TableCell>
          <OutlinedInput
            value={props?.initialYieldContracted}//{props.editDisplay ? (props?.initialYieldContracted != null ? Number(props?.initialYieldContracted).toFixed(2) : '') : props?.initialYieldContracted}
            size="small"
            sx={{ width: '150px' }} readOnly={!props.isEditable} onChange={(e) => handleInitialyieldcontracted(e.target.value)} />
        </TableCell>
        <TableCell>
          <OutlinedInput
            value={props?.nominalEquivalentYield}//{props.editDisplay ? (props?.nominalEquivalentYield != null ? Number(props?.nominalEquivalentYield).toFixed(2) : '') : props?.nominalEquivalentYield}
            size="small"
            sx={{ width: '150px' }} readOnly={!props.isEditable} onChange={(e) => handleNominalequivalentyield(e.target.value)} />
        </TableCell>
        <TableCell>
          <OutlinedInput
            value={props?.trueEquivalentYield}//{props.editDisplay ? (props?.trueEquivalentYield != null ? Number(props?.trueEquivalentYield).toFixed(2) : '') : props?.trueEquivalentYield}
            size="small"
            sx={{ width: '150px' }} readOnly={!props.isEditable} onChange={(e) => handleTrueequivalentyield(e.target.value)} />
        </TableCell>
        <TableCell>
          <OutlinedInput
            value={props?.reversionaryYield}//{props.editDisplay ? (props?.reversionaryYield != null ? Number(props?.reversionaryYield).toFixed(2) : '') : props?.reversionaryYield}
            size="small"
            sx={{ width: '150px' }} readOnly={!props.isEditable} onChange={(e) => handleReversionaryyield(e.target.value)} />
        </TableCell>


        {/* conditional  */}
        {props.displayProformaFields && <>
          <TableCell>
            <OutlinedInput
              value={props?.terminalCapRate}//{props.editDisplay ? (props?.terminalCapRate != null ? Number(props?.terminalCapRate).toFixed(2) : '') : props?.terminalCapRate}
              size="small"
              sx={{ width: '150px' }} readOnly={!props.isEditable} onChange={(e) => handleTerminalCapRate(e.target.value)} />
          </TableCell>
          <TableCell>
            <OutlinedInput
              value={props?.discountRate}//{props.editDisplay ? (props?.discountRate != null ? Number(props?.discountRate).toFixed(2) : '') : props?.discountRate}
              size="small"
              sx={{ width: '150px' }} readOnly={!props.isEditable} onChange={(e) => handleDiscountrate(e.target.value)} />
          </TableCell>
          <TableCell>
            <OutlinedInput
              value={(props.assumedHoldingPeriod)}
              size="small"
              sx={{ width: '150px' }} readOnly={!props.isEditable} onChange={(e) => handleAssumedholdingperiod(e.target.value)} />
          </TableCell>
          <TableCell>
            <OutlinedInput
              value={props?.growthRates}//{props.editDisplay ? (props?.growthRates != null ? Number(props?.growthRates).toFixed(2) : '') : props?.growthRates}
              size="small"
              sx={{ width: '150px' }} readOnly={!props.isEditable} onChange={(e) => handleGrowthrates(e.target.value)} />
          </TableCell>
          <TableCell>
            <OutlinedInput
              value={(props.netExitValue)}
              size="small"
              sx={{ width: '150px' }} readOnly={!props.isEditable} onChange={(e) => handleNetexitvalue(e.target.value)} />
          </TableCell>
          <TableCell>
            <OutlinedInput
              value={props?.forwardInitialYield}//{props.editDisplay ? (props?.forwardInitialYield != null ? Number(props?.forwardInitialYield).toFixed(2) : '') : props?.forwardInitialYield}
              size="small"
              sx={{ width: '150px' }} readOnly={!props.isEditable} onChange={(e) => handleForwardinitialyield(e.target.value)} />
          </TableCell>
        </>
        }

      </TableRow>
    </>
  )
};

export const GlobalAppraisalPropertyTable = (propData: any) => {
  const [selectedCurrentProperty, setSelectedCurrentProperty] = useState([]);
  const [priorSelectedProperty, setPriorSelectedProperty] = useState<Properties[]>([]);
  const format = new DecimalFormating();

  const handleDataFromChild = (propertyId: any) => {
    var tempselectedCurrentProperty = propData.currentData.filter((property: any) => property.propertyId === propertyId);
    setSelectedCurrentProperty(tempselectedCurrentProperty);

    var temppriorCurrentProperty = propData?.priorData?.filter((property: any) => property.propertyId === propertyId);
    setPriorSelectedProperty(temppriorCurrentProperty);
  }
  

  var propertyRows = propData.currentData?.map(function (element: Properties,index) {
    return <TableRowComponent
      propertyId={element.propertyId}
      propertyName={element.propertyName}
      propertyType={element.propertyType}
      editDisplay={propData.editDisplay}
      propertyValueDate={element.propertyValueDate}
      netRentPassing={element.netRentPassing}//{element.netRentPassing ? formatNumber(Number(element.netRentPassing)) : ''}
      currency={element.currency}
      rentalValue={element.rentalValue}//{element.rentalValue ?formatNumber(Number(element.rentalValue)) : ''}
      grossValue={element.grossValue}//{element.grossValue ?formatNumber(Number(element.grossValue)) : ''}
      capitalExpenditure={element.capitalExpenditure}//{element.capitalExpenditure ?formatNumber(Number(element.capitalExpenditure)) : ''}
      acquisitionCosts={element.acquisitionCosts}//{element.acquisitionCosts ?formatNumber(Number(element.acquisitionCosts)) : ''}
      netValue={element.netValue}//{element.netValue ?formatNumber(Number(element.netValue)) : ''}
      sayValue={element.sayValue}//{element.sayValue ?formatNumber(Number(element.sayValue)) : ''}
      initialYieldValuation={element.initialYieldValuation}//{format.formatToTwoDecimalPlaces(element.initialYieldValuation)}
      initialYieldContracted={element.initialYieldContracted}//{element.initialYieldContracted ? element.initialYieldContracted : ''}
      nominalEquivalentYield={element.nominalEquivalentYield}// ? element.nominalEquivalentYield : ''}
      trueEquivalentYield={element.trueEquivalentYield}// ? element.trueEquivalentYield : ''}
      reversionaryYield={element.reversionaryYield}// ? element.reversionaryYield : ''}
      terminalCapRate={element.terminalCapRate}// ? element.terminalCapRate : ''}
      discountRate={element.discountRate}// ? element.discountRate : ''}
      assumedHoldingPeriod={element.assumedHoldingPeriod}//{element.assumedHoldingPeriod ? formatNumber(Number(element.assumedHoldingPeriod)) : ''}
      growthRates={element.growthRates}// ? element.growthRates : ''}
      netExitValue={element.netExitValue}//{element.netExitValue ? formatNumber(Number(element.netExitValue)) : ''}
      forwardInitialYield={element.forwardInitialYield}// ? element.forwardInitialYield : ''}


      priorData={priorSelectedProperty}
      currentData={selectedCurrentProperty}
      key={element.propertyId}
      selected
      sendDataToParent={handleDataFromChild}
      displayProformaFields={propData.displayProformaFields}

      isGermanFund={propData.isGermanFund}
      isViewForm={propData.isViewForm}
      index={index}
      isEditable = {propData.isEditable}
      handlePropertyValuedate={propData.handlePropertyValuedate}
      handleRentalValue={propData.handleRentalValue}
      handleNetrentpassing = {propData.handleNetrentpassing}
      handleGrossvalue = {propData.handleGrossvalue}
      handleCapitalexpenditure = {propData.handleCapitalexpenditure}
      handleAcquisitioncosts = {propData.handleAcquisitioncosts}
      handleNetvalue = {propData.handleNetvalue}
      handleSayvalue = {propData.handleSayvalue}
      handleInitialyieldvaluation = {propData.handleInitialyieldvaluation}
      handleInitialyieldcontracted = {propData.handleInitialyieldcontracted}
      handleNominalequivalentyield = {propData.handleNominalequivalentyield}
      handleTrueequivalentyield = {propData.handleTrueequivalentyield}
      handleReversionaryyield = {propData.handleReversionaryyield}
      handleAssumedholdingperiod = {propData.handleAssumedholdingperiod}
      handleDiscountrate = {propData.handleDiscountrate}
      handleForwardinitialyield = {propData.handleForwardinitialyield}
      handleGrowthrates = {propData.handleGrowthrates}
      handleNetexitvalue = {propData.handleNetexitvalue}
      handleTerminalCapRate = {propData.handleTerminalCapRate}
      handleCurrency = {propData.handleCurrency}
      currencyError={propData.currencyErrors?.[index] ?? false}
    />;
  })

  return (
    <TableContainer sx={{ maxHeight: 440 }} component={Paper}>
      <Table
        sx={{ minWidth: 650, maxHeight: 440 }}
        stickyHeader
        size="small"
        aria-label="a dense table"
        className="global-appraisal-property-table"
      >
        <TableHead>
          <TableRow>
            <TableCell>Property ID</TableCell>
            <TableCell>Property Name</TableCell>
            <TableCell>Property Type</TableCell>
            <TableCell>Currency</TableCell>
            {
              (propData.isGermanFund)  &&
              <TableCell>Property Value Date</TableCell>
            }
            <TableCell>Net Rent Passing</TableCell>
            <TableCell>Rental Value</TableCell>
            <TableCell>Gross Value</TableCell>
            <TableCell>Capital Expenditure</TableCell>
            <TableCell>Acquisition Costs</TableCell>
            <TableCell>Net Value</TableCell>
            <TableCell>Say Value</TableCell>
            <TableCell>Initial Yield (Valuation Rent)</TableCell>
            <TableCell>Initial Yield (Contracted Rent)</TableCell>
            <TableCell>Nominal Equivalent Yield</TableCell>
            <TableCell>True Equivalent Yield</TableCell>
            <TableCell>Reversionary Yield</TableCell>

            {propData.displayProformaFields && <>
            <TableCell>Terminal CapRate</TableCell>
            <TableCell>Discount Rate</TableCell>
            <TableCell>Assumed Holding Period</TableCell>
            <TableCell>Growth Rates</TableCell>
            <TableCell>Net Exit Value</TableCell>
            <TableCell>Forward Initial Yield</TableCell>
            </>}

          </TableRow>
        </TableHead>
        <TableBody>
          {propertyRows}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
